module.exports = __webpack_public_path__ + "img/game_main_pc_35_off.0fa33e41.png";